module.exports = __webpack_public_path__ + "static/media/bg-tour-detail.92972eec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg-tour-detail.jpg
// module id = 331
// module chunks = 0